module.exports = __webpack_public_path__ + "img/tysabri_logo.8c11bcad.png";